import React from "react";

export default function Aftermovies() {
  return <div>aftermovies</div>;
}
